export class CreditCardsToSave {
    Number      : number;
    Expiration  : string;
    Issue       : string;
    StartDate   : string;
    SetPrimary  : boolean;
    CardIsToken : boolean;
}